import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VouchersListComponent} from "@app/features/vouchers/vouchers-list/vouchers-list.component";
import {CreateVoucherComponent} from "@app/features/vouchers/create-voucher/create-voucher.component";

const routes: Routes = [
  {
    path: '',
    component: VouchersListComponent

  },  {
    path: ':id',
    component: CreateVoucherComponent

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VouchersRoutingModule {
}
